import { defineComponent as _defineComponent } from 'vue'

import type { PropType } from 'vue'
import type { ViewProperties } from '@/models/ViewProperties'
import type { Game } from '@/models/Game'

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'TicketsGameEdit',
  props: {
  viewProperties: {
    required: true,
    type: Object as PropType<ViewProperties>
  },
},
  emits: ['cancel', 'save'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props




// eslint-disable-next-line @typescript-eslint/no-unused-vars
const cancel = () => {
  emit('cancel')
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const save = (game: Game) => {
  emit('save', game)
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars



const __returned__ = { props, cancel, save, emit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})